import React from 'react';
import { useTranslation } from 'react-i18next';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  label?: string;
}

const sizeClasses = {
  sm: 'h-6 w-6',
  md: 'h-12 w-12',
  lg: 'h-16 w-16',
};

export const Spinner: React.FC<SpinnerProps> = ({ size = 'md', className = '', label }) => {
  const { t } = useTranslation();
  const resolvedLabel = label ?? t('common.loading');
  return (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      <div
        className={`animate-spin rounded-full border-b-2 border-primary ${sizeClasses[size]}`}
        aria-label={resolvedLabel}
      />
      {resolvedLabel && <p className="text-white mt-4">{resolvedLabel}</p>}
    </div>
  );
};
